export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00449.43ef8001.png";